import { useFichaAnexosPrevia } from "./use-ficha-anexos-previa";
import { FichaAnexosPreviaView } from "./view-ficha-anexos-previa";
import type { FichaAnexosPreviaProps } from "./types-ficha-anexos-previa";

export function FichaAnexosPrevia(props: FichaAnexosPreviaProps) {
  const vm = useFichaAnexosPrevia(props);

  return <FichaAnexosPreviaView {...vm} />;
}

export type * from "./types-ficha-anexos-previa";
